(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Filters = exports.default = /*#__PURE__*/function () {
  function Filters(mapInstance, items) {
    _classCallCheck(this, Filters);
    this.mapInstance = mapInstance;
    this.items = items;
    this.ACTIVE_FILTER_ITEM_CSS_CLASS_SELECTOR = 'administrativeUnitsMap__filter--active';
    this.attachListeners();
  }
  return _createClass(Filters, [{
    key: "displayAll",
    value: function displayAll() {
      this.updateFilterActiveState(document.getElementById('mapa-vse')); // map exists so this should be present as well
      this.mapInstance.displayLayer();
    }
  }, {
    key: "displayLayer",
    value: function displayLayer(item) {
      this.updateFilterActiveState(item);
      this.mapInstance.displayLayer(item.dataset.slug);
    }
  }, {
    key: "attachListeners",
    value: function attachListeners() {
      var _this = this;
      this.items.forEach(function (item) {
        return item.addEventListener('click', function (ev) {
          window.history.pushState(null, '', item.children[0].getAttribute('href'));
          ev.preventDefault();
          _this.displayLayer(item);
        });
      });
    }
  }, {
    key: "updateFilterActiveState",
    value: function updateFilterActiveState(activeItem) {
      var _this2 = this;
      this.items.forEach(function (item) {
        return item.classList.remove(_this2.ACTIVE_FILTER_ITEM_CSS_CLASS_SELECTOR);
      });
      activeItem.classList.add(this.ACTIVE_FILTER_ITEM_CSS_CLASS_SELECTOR);
    }
  }]);
}();

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoWindow = void 0;
var _utils = require("./utils");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InfoWindow = exports.InfoWindow = /*#__PURE__*/function () {
  function InfoWindow(mapInstance) {
    _classCallCheck(this, InfoWindow);
    this.mapInstance = mapInstance;
    // We want only one instance of InfoWindow due to closing previous opened windows
    this.infoWindow = new google.maps.InfoWindow();
  }
  return _createClass(InfoWindow, [{
    key: "display",
    value: function display(unit, marker) {
      this.infoWindow.close(); // Close previously opened infowindow
      this.infoWindow.setContent(InfoWindow.buildContent(unit)); // set content of info window
      this.infoWindow.open(this.mapInstance, marker); // open window, which was clicked by user
    }
  }], [{
    key: "buildContent",
    value: function buildContent(unit) {
      var containerEl = document.createElement('div');
      containerEl.id = 'infowindow';
      containerEl.classList.add('administrativeUnitsMap__infoWindow');
      if (unit.image !== null) {
        var imageContainerEl = containerEl.appendChild(document.createElement('div'));
        imageContainerEl.classList.add('administrativeUnitsMap__infoWindowImageContainer');
        var imageEl = imageContainerEl.appendChild(document.createElement('img'));
        imageEl.classList.add('administrativeUnitsMap__infoWindowImage');
        imageEl.src = unit.image;
      }
      var contentEl = containerEl.appendChild(document.createElement('div'));
      var metaEl = contentEl.appendChild(document.createElement('div'));
      metaEl.innerHTML = (0, _utils.resolveUnitTitle)(unit);
      metaEl.innerHTML += "<br>Adresa: ".concat(unit.address);
      if (unit.chairman !== null) {
        metaEl.innerHTML += "<br>P\u0159edseda: ".concat(unit.chairman);
      }
      if (unit.website !== null) {
        metaEl.innerHTML += "<br>Web: <a href=\"".concat(unit.website, "\" target=\"_blank\">").concat(unit.website, "</a>");
      }
      if (unit.email !== null) {
        metaEl.innerHTML += "<br>E-mail: <a href=\"mailto:".concat(unit.email, "\">").concat(unit.email, "</a>");
      }
      if (unit.description !== null) {
        var descriptionEl = contentEl.appendChild(document.createElement('p'));
        descriptionEl.classList.add('administrativeUnitsMap__infoWindowDescription');
        descriptionEl.innerHTML += unit.description;
      }
      return containerEl;
    }
  }]);
}();

},{"./utils":5}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _InfoWindow = require("./InfoWindow");
var _utils = require("./utils");
var _tsOverlappingMarkerSpiderfier = require("ts-overlapping-marker-spiderfier");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Map = exports.default = /*#__PURE__*/function () {
  function Map(mapElement) {
    _classCallCheck(this, Map);
    // Maps Google map to place where we want display our map
    this.map = new google.maps.Map(mapElement);
    // For layers by type, @source: https://stackoverflow.com/a/23036174
    this.mapLayers = new google.maps.MVCObject();
    this.infoWindow = new _InfoWindow.InfoWindow(this.map);
    this.markerCluster = new _tsOverlappingMarkerSpiderfier.OverlappingMarkerSpiderfier(this.map);
    this.slugs = [];
    var organizationalUnitsInJSON = mapElement.getAttribute('data-organizationalUnits');
    if (organizationalUnitsInJSON === null) {
      throw new Error('Organizational units has not been passed.');
    }
    this.organizationalUnits = JSON.parse(organizationalUnitsInJSON);
    this.placeMarkers();
    this.centerAndZoom();
  }
  // place markers and set layers by type for filter
  return _createClass(Map, [{
    key: "placeMarkers",
    value: function placeMarkers() {
      var _this = this;
      this.organizationalUnits.forEach(function (unit) {
        var slug = (0, _utils.resolveUnitTypeSlug)(unit);
        if (typeof slug !== 'undefined' && _this.slugs.indexOf(slug) === -1) {
          _this.slugs.push(slug);
          _this.mapLayers.set(slug, _this.map);
        }
        _this.placeMarker(unit);
      });
    }
    // Inspiration from: https://stackoverflow.com/a/30013345
  }, {
    key: "placeMarker",
    value: function placeMarker(unit) {
      var _this2 = this;
      // make marker and set option
      var marker = new google.maps.Marker({
        position: {
          lat: unit.lat,
          lng: unit.lng
        },
        map: this.map,
        title: (0, _utils.resolveUnitTitle)(unit),
        icon: "https://brontosaurus.cz/wp-content/uploads/2024/12/".concat((0, _utils.resolveIconFileName)(unit))
      });
      // Bind marker.map to the specific slug property of unitTypesLayers which is set and unset below [1]
      marker.bindTo('map', this.mapLayers, (0, _utils.resolveUnitTypeSlug)(unit));
      // Add spider listener for opening and closing info window
      this.markerCluster.addMarker(marker, function () {
        _this2.infoWindow.display(unit, marker);
      });
    }
  }, {
    key: "displayLayer",
    value: function displayLayer() {
      var _this3 = this;
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.slugs.forEach(function (slug) {
        return _this3.mapLayers.set(slug, slug === filter || filter === null ? _this3.map : null);
      });
    }
  }, {
    key: "centerAndZoom",
    value: function centerAndZoom() {
      this.map.setCenter(new google.maps.LatLng(49.7437572, 15.3386383)); // Czechia geographic center, see https://en.mapy.cz/s/gupehogeha
      this.map.setZoom(7);
    }
  }]);
}();

},{"./InfoWindow":2,"./utils":5,"ts-overlapping-marker-spiderfier":7}],4:[function(require,module,exports){
"use strict";

var _Map = _interopRequireDefault(require("./Map"));
var _Filters = _interopRequireDefault(require("./Filters"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
// @ts-ignore
var loadGoogleMapsApi = require('load-google-maps-api'); // must be this way, because of exporting using `export =`

document.addEventListener('DOMContentLoaded', function () {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return loadGoogleMapsApi({
            key: 'AIzaSyDsxejbWcsI1eb4eoQJq47Eq9qxvSCMXSc'
          });
        case 3:
          initialize();
          _context.next = 9;
          break;
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
});
// Initialize and add the mapInstance
function initialize() {
  var mapEl = document.getElementById('map');
  if (mapEl === null) {
    // don't do anything if no map
    return;
  }
  var map = new _Map.default(mapEl); // initialize map
  var filters = new _Filters.default(map, document.querySelectorAll('.administrativeUnitsMap__filter')); // initialize filters (listen to click events)
  // custom behavior for about-structure page
  // ideally, administrativeUnitsMap should export API, but there's no time play with it now
  var unitBaseLinkEl = document.getElementById('about-structure-unit-base-link');
  if (unitBaseLinkEl !== null) {
    unitBaseLinkEl.addEventListener('click', function (_) {
      return (
        // listen to base unit link as well
        filters.displayLayer(document.getElementById('mapa-zakladni-clanky'))
      );
    }); // map exists so this should be present as well
  }
  window.addEventListener('load', function () {
    var hash = window.location.hash.substring(1);
    var selectedFilterLinkEl = hash !== '' ? document.querySelector(".administrativeUnitsMap__filters #".concat(hash)) : null;
    if (selectedFilterLinkEl !== null) {
      // no filtering element with given hash found => do not filter
      filters.displayLayer(selectedFilterLinkEl);
    } else {
      filters.displayAll();
    }
  });
}

},{"./Filters":1,"./Map":3,"load-google-maps-api":6}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveIconFileName = resolveIconFileName;
exports.resolveUnitTitle = resolveUnitTitle;
exports.resolveUnitTypeSlug = resolveUnitTypeSlug;
function resolveUnitTypeSlug(unit) {
  if (unit.isOfTypeClub) {
    return 'club';
  } else if (unit.isOfTypeBase) {
    return 'base';
  } else if (unit.isOfTypeRegional) {
    return 'regional';
  } else if (unit.isOfTypeOffice) {
    return 'office';
  } else if (unit.isOfTypeChildren) {
    return 'children';
  } else {
    // no option selected, fall back to Google Maps default marker
    return;
  }
}
function resolveIconFileName(unit) {
  return "icon-marker-".concat(resolveUnitTypeSlug(unit), ".svg");
}
function resolveUnitTitle(unit) {
  var type = resolveUnitTypeLabel(unit);
  if (type === null) {
    return unit.name;
  }
  return "".concat(unit.name, " \u2013 ").concat(type);
}
function resolveUnitTypeLabel(unit) {
  switch (true) {
    case unit.isOfTypeClub:
      return 'klub';
    case unit.isOfTypeBase:
      return 'základní článek';
    case unit.isOfTypeRegional:
      return 'regionální centrum';
    case unit.isOfTypeOffice:
      return 'ústředí';
    case unit.isOfTypeChildren:
      return 'dětský oddíl';
  }
  return null;
}

},{}],6:[function(require,module,exports){
const API_URL = 'https://maps.googleapis.com/maps/api/js'
const CALLBACK_NAME = '__googleMapsApiOnLoadCallback'

const optionsKeys = ['channel', 'client', 'key', 'language', 'region', 'v']

let promise = null

module.exports = function (options = {}) {
  promise =
    promise ||
    new Promise(function (resolve, reject) {
      // Reject the promise after a timeout
      const timeoutId = setTimeout(function () {
        window[CALLBACK_NAME] = function () {} // Set the on load callback to a no-op
        reject(new Error('Could not load the Google Maps API'))
      }, options.timeout || 10000)

      // Hook up the on load callback
      window[CALLBACK_NAME] = function () {
        if (timeoutId !== null) {
          clearTimeout(timeoutId)
        }
        resolve(window.google.maps)
        delete window[CALLBACK_NAME]
      }

      // Prepare the `script` tag to be inserted into the page
      const scriptElement = document.createElement('script')
      const params = [`callback=${CALLBACK_NAME}`]
      optionsKeys.forEach(function (key) {
        if (options[key]) {
          params.push(`${key}=${options[key]}`)
        }
      })
      if (options.libraries && options.libraries.length) {
        params.push(`libraries=${options.libraries.join(',')}`)
      }
      scriptElement.src = `${options.apiUrl || API_URL}?${params.join('&')}`

      // Insert the `script` tag
      document.body.appendChild(scriptElement)
    })
  return promise
}

},{}],7:[function(require,module,exports){
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.OMS = {})));
}(this, (function (exports) { 'use strict';

var __extends = (window && window.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var MarkerStatus = /** @class */ (function () {
    function MarkerStatus() {
    }
    // universal status
    MarkerStatus.SPIDERFIED = 'SPIDERFIED';
    // statuses reported under standard regine
    MarkerStatus.SPIDERFIABLE = 'SPIDERFIABLE';
    MarkerStatus.UNSPIDERFIABLE = 'UNSPIDERFIABLE';
    // status reported under simple status update regime only
    MarkerStatus.UNSPIDERFIED = 'UNSPIDERFIED';
    return MarkerStatus;
}());
var OverlappingMarkerSpiderfier = /** @class */ (function () {
    function OverlappingMarkerSpiderfier(map, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        this.map = map;
        this.spiderfiedZIndex = google.maps.Marker.MAX_ZINDEX + 20000;
        this.highlightedLegZIndex = google.maps.Marker.MAX_ZINDEX + 10000;
        this.usualLegZIndex = google.maps.Marker.MAX_ZINDEX + 1;
        this.markers = [];
        this.markerListenerRefs = [];
        this.spiderfied = false;
        this.spiderfying = false;
        this.unspiderfying = false;
        this.legColors = {
            highlighted: (_a = {}, _a[google.maps.MapTypeId.HYBRID] = '#f00', _a[google.maps.MapTypeId.ROADMAP] = '#f00', _a[google.maps.MapTypeId.SATELLITE] = '#f00', _a[google.maps.MapTypeId.TERRAIN] = '#f00', _a),
            usual: (_b = {}, _b[google.maps.MapTypeId.HYBRID] = '#fff', _b[google.maps.MapTypeId.ROADMAP] = '#444', _b[google.maps.MapTypeId.SATELLITE] = '#fff', _b[google.maps.MapTypeId.TERRAIN] = '#444', _b)
        };
        this.markersWontHide = false;
        this.markersWontMove = false;
        this.basicFormatEvents = false;
        this.keepSpiderfied = false;
        this.ignoreMapClick = false;
        this.nearbyDistance = 20;
        this.circleSpiralSwitchover = 9;
        this.circleFootSeparation = 23;
        this.circleStartAngle = Math.PI / 6;
        this.spiralFootSeparation = 26;
        this.spiralLengthStart = 11;
        this.spiralLengthFactor = 4;
        this.legWeight = 1.5;
        this.VERSION = '1.0.3';
        var keys = OverlappingMarkerSpiderfier.optionAttributes
            .filter(function (key) { return typeof options[key] !== 'undefined'; });
        keys.forEach(function (key) {
            _this[key] = options[key];
        });
        this.projectionHelper = new (/** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1(map) {
                var _this = _super.call(this) || this;
                _this.setMap(map);
                return _this;
            }
            class_1.prototype.draw = function () {
            };
            return class_1;
        }(google.maps.OverlayView)))(this.map);
        this.initMarkerArrays();
        this.listeners = {};
        this.formatIdleListener = this.formatTimeoutId = null;
        this.addListener('click', function (marker, event) { return google.maps.event.trigger(marker, 'spider_click', event); }); // new-style events, easier to integrate
        this.addListener('format', function (marker, status) { return google.maps.event.trigger(marker, 'spider_format', status); });
        if (!this.ignoreMapClick) {
            google.maps.event.addListener(this.map, 'click', function () { return _this.unspiderfy(); });
        }
        google.maps.event.addListener(this.map, 'maptypeid_changed', function () { return _this.unspiderfy(); });
        google.maps.event.addListener(this.map, 'zoom_changed', function () {
            _this.unspiderfy();
            if (!_this.basicFormatEvents) {
                return _this.formatMarkers();
            }
        });
        var _a, _b;
    }
    OverlappingMarkerSpiderfier.prototype.doFormatMarkers = function () {
        var result = [];
        var marker;
        var status;
        // only formatMarkers is allowed to call this directly
        if (this.basicFormatEvents) {
            for (var i = 0; i < this.markers.length; i++) {
                marker = this.markers[i];
                status = marker['_omsData'] ? OverlappingMarkerSpiderfier.markerStatus.SPIDERFIED :
                    OverlappingMarkerSpiderfier.markerStatus.UNSPIDERFIED;
                result.push(this.trigger('format', marker, status));
            }
            return result;
        }
        var proximities = this.markerProximityData(); // {pt, willSpiderfy}[]
        for (var i = 0; i < this.markers.length; i++) {
            marker = this.markers[i];
            status = marker['_omsData'] ?
                OverlappingMarkerSpiderfier.markerStatus.SPIDERFIED :
                proximities[i].willSpiderfy ?
                    OverlappingMarkerSpiderfier.markerStatus.SPIDERFIABLE :
                    OverlappingMarkerSpiderfier.markerStatus.UNSPIDERFIABLE;
            result.push(this.trigger('format', marker, status));
        }
        return result;
    };
    OverlappingMarkerSpiderfier.prototype.formatMarkers = function () {
        var _this = this;
        if (this.basicFormatEvents) {
            return;
        }
        if (this.formatTimeoutId) {
            return;
        } // only format markers once per run loop (in case e.g. being called repeatedly from addMarker)
        return this.formatTimeoutId = window.setTimeout(function () {
            _this.formatTimeoutId = null;
            if (_this.formatIdleListener) {
                return;
            }
            _this.formatIdleListener = google.maps.event.addListenerOnce(_this.map, 'idle', function () {
                _this.formatIdleListener = null;
                _this.doFormatMarkers();
            });
        });
    };
    OverlappingMarkerSpiderfier.prototype.generatePtsCircle = function (count, centerPt) {
        var circumference = this.circleFootSeparation * (2 + count);
        var legLength = circumference / (2 * Math.PI); // = radius from circumference
        var angleStep = 2 * Math.PI / count;
        var result = [];
        for (var i = 0, end = count, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
            var angle = this.circleStartAngle + i * angleStep;
            result.push(new google.maps.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle)));
        }
        return result;
    };
    OverlappingMarkerSpiderfier.prototype.generatePtsSpiral = function (count, centerPt) {
        var legLength = this.spiralLengthStart;
        var angle = 0;
        var result = [];
        for (var i = 0, end = count, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
            angle += this.spiralFootSeparation / legLength + i * 0.0005;
            var pt = new google.maps.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle));
            legLength += Math.PI * 2 * this.spiralLengthFactor / angle;
            result.push(pt);
        }
        return result;
    };
    OverlappingMarkerSpiderfier.prototype.initMarkerArrays = function () {
        this.markers = [];
        this.markerListenerRefs = [];
    };
    OverlappingMarkerSpiderfier.prototype.llToPt = function (ll) {
        return this.projectionHelper.getProjection().fromLatLngToDivPixel(ll);
    };
    OverlappingMarkerSpiderfier.prototype.makeHighlightListenerFuncs = function (marker) {
        var _this = this;
        var mapTypeId = this.map.getMapTypeId();
        return {
            highlight: function () { return marker['_omsData'].leg.setOptions({
                strokeColor: _this.legColors.highlighted[mapTypeId],
                zIndex: _this.highlightedLegZIndex
            }); },
            unhighlight: function () { return marker['_omsData'].leg.setOptions({
                strokeColor: _this.legColors.usual[mapTypeId],
                zIndex: _this.usualLegZIndex
            }); }
        };
    };
    OverlappingMarkerSpiderfier.prototype.markerChangeListener = function (marker, positionChanged) {
        if (this.spiderfying || this.unspiderfying) {
            return;
        }
        if (marker['_omsData'] && (positionChanged || !marker.getVisible())) {
            this.unspiderfy(positionChanged ? marker : null);
        }
        return this.formatMarkers();
    };
    OverlappingMarkerSpiderfier.prototype.markerProximityData = function () {
        var _this = this;
        if (this.projectionHelper.getProjection() == null) {
            throw 'Must wait for \'idle\' event on map before calling markersNearAnyOtherMarker';
        }
        var nDist = this.nearbyDistance;
        var pxSq = nDist * nDist;
        var mData = this.markers.map(function (marker) { return ({
            pt: _this.llToPt(marker['_omsData'] && marker['_omsData'].usualPosition || marker.position),
            willSpiderfy: false
        }); });
        for (var i1 = 0; i1 < this.markers.length; i1++) {
            var m1 = this.markers[i1];
            if (m1.getMap() == null || !m1.getVisible()) {
                continue;
            } // marker not visible: ignore
            var m1Data = mData[i1];
            if (m1Data.willSpiderfy) {
                continue;
            } // true in the case that we've assessed an earlier marker that was near this one
            for (var i2 = 0; i2 < this.markers.length; i2++) {
                var m2 = this.markers[i2];
                if (i2 === i1) {
                    continue;
                } // markers cannot be near themselves: ignore
                if (m2.getMap() == null || !m2.getVisible()) {
                    continue;
                } // marker not visible: ignore
                var m2Data = mData[i2];
                if (i2 < i1 && !m2Data.willSpiderfy) {
                    continue;
                } // if i2 < i1, m2 has already been checked for proximity to any other marker;
                // so if willSpiderfy is false, it cannot be near any other marker, including this one (m1)
                if (OverlappingMarkerSpiderfier.ptDistanceSq(m1Data.pt, m2Data.pt) < pxSq) {
                    m1Data.willSpiderfy = m2Data.willSpiderfy = true;
                    break;
                }
            }
        }
        return mData;
    };
    OverlappingMarkerSpiderfier.minExtract = function (set, callback) {
        // destructive! returns minimum, and also removes it from the set
        var bestIndex = null;
        var bestValue = null;
        for (var index = 0; index < set.length; index++) {
            var item = set[index];
            var value = callback(item);
            if (bestIndex === null || value < bestValue) {
                bestValue = value;
                bestIndex = index;
            }
        }
        return set.splice(bestIndex, 1)[0];
    };
    OverlappingMarkerSpiderfier.ptAverage = function (points) {
        var _a = points.reduce(function (result, current) {
            result.x += current.x;
            result.y += current.y;
            return result;
        }, { x: 0, y: 0 }), x = _a.x, y = _a.y;
        return new google.maps.Point(x / points.length, y / points.length);
    };
    OverlappingMarkerSpiderfier.ptDistanceSq = function (pt1, pt2) {
        var dx = pt1.x - pt2.x;
        var dy = pt1.y - pt2.y;
        return dx * dx + dy * dy;
    };
    OverlappingMarkerSpiderfier.prototype.ptToLl = function (pt) {
        return this.projectionHelper.getProjection().fromDivPixelToLatLng(pt);
    };
    OverlappingMarkerSpiderfier.prototype.spiderfy = function (markerData, nonNearbyMarkers) {
        var _this = this;
        var mapTypeId = this.map.getMapTypeId();
        var numFeet = markerData.length;
        this.spiderfying = true;
        var bodyPt = OverlappingMarkerSpiderfier.ptAverage(markerData.map(function (data) { return data.markerPt; }));
        var footPts = numFeet >= this.circleSpiralSwitchover ?
            this.generatePtsSpiral(numFeet, bodyPt).reverse() : // match from outside in => less criss-crossing
            this.generatePtsCircle(numFeet, bodyPt);
        var spiderfiedMarkers = footPts.map(function (footPt) {
            var footLl = _this.ptToLl(footPt);
            var nearestMarkerDatum = OverlappingMarkerSpiderfier.minExtract(markerData, function (data) { return OverlappingMarkerSpiderfier.ptDistanceSq(data.markerPt, footPt); });
            var marker = nearestMarkerDatum.marker;
            var leg = new google.maps.Polyline({
                map: _this.map,
                path: [marker.position, footLl],
                strokeColor: _this.legColors.usual[_this.map.getMapTypeId()],
                strokeWeight: _this.legWeight,
                zIndex: _this.usualLegZIndex
            });
            marker['_omsData'] = {
                usualPosition: marker.getPosition(),
                usualZIndex: marker.getZIndex(),
                leg: leg
            };
            if (_this.legColors.highlighted[mapTypeId] !== _this.legColors.usual[mapTypeId]) {
                var highlightListenerFuncs = _this.makeHighlightListenerFuncs(marker);
                marker['_omsData'].hightlightListeners = {
                    highlight: google.maps.event.addListener(marker, 'mouseover', highlightListenerFuncs.highlight),
                    unhighlight: google.maps.event.addListener(marker, 'mouseout', highlightListenerFuncs.unhighlight)
                };
            }
            _this.trigger('format', marker, OverlappingMarkerSpiderfier.markerStatus.SPIDERFIED);
            marker.setPosition(footLl);
            marker.setZIndex(Math.round(_this.spiderfiedZIndex + footPt.y)); // lower markers cover higher
            return marker;
        });
        this.spiderfying = false;
        this.spiderfied = true;
        return this.trigger('spiderfy', spiderfiedMarkers, nonNearbyMarkers);
    };
    OverlappingMarkerSpiderfier.prototype.spiderListener = function (marker, event) {
        var markerSpiderfied = !!marker['_omsData'];
        if (!markerSpiderfied || !this.keepSpiderfied) {
            this.unspiderfy();
        }
        if (markerSpiderfied || this.map.getStreetView().getVisible() || this.map.getMapTypeId() === 'GoogleEarthAPI') {
            // don't spiderfy in Street View or GE Plugin!
            return this.trigger('click', marker, event);
        }
        var nearbyMarkerData = [];
        var nonNearbyMarkers = [];
        var nDist = this.nearbyDistance;
        var pxSq = nDist * nDist;
        var markerPt = this.llToPt(marker.position);
        for (var i = 0; i < this.markers.length; i++) {
            var m = this.markers[i];
            if (m.map == null || !m.getVisible()) {
                continue;
            } // at 2011-08-12, property m.visible is undefined in API v3.5
            var mPt = this.llToPt(m.position);
            if (OverlappingMarkerSpiderfier.ptDistanceSq(mPt, markerPt) < pxSq) {
                nearbyMarkerData.push({ marker: m, markerPt: mPt });
            }
            else {
                nonNearbyMarkers.push(m);
            }
        }
        if (nearbyMarkerData.length === 1) {
            // 1 => the one clicked => none nearby
            return this.trigger('click', marker, event);
        }
        return this.spiderfy(nearbyMarkerData, nonNearbyMarkers);
    };
    OverlappingMarkerSpiderfier.prototype.trigger = function (eventName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.listeners[eventName]) {
            return this.listeners[eventName].map(function (listener) { return listener.apply(void 0, args); });
        }
        return [];
    };
    OverlappingMarkerSpiderfier.prototype.addMarker = function (marker, spiderClickHandler) {
        marker.setMap(this.map);
        return this.trackMarker(marker, spiderClickHandler);
    };
    OverlappingMarkerSpiderfier.prototype.trackMarker = function (marker, spiderClickHandler) {
        var _this = this;
        if (marker['_oms']) {
            return this;
        }
        marker['_oms'] = true;
        // marker.setOptions optimized: no  # 'optimized' rendering is sometimes buggy, but seems mainly OK on current GMaps
        var listenerRefs = [
            google.maps.event.addListener(marker, 'click', function (event) { return _this.spiderListener(marker, event); })
        ];
        if (!this.markersWontHide) {
            listenerRefs.push(google.maps.event.addListener(marker, 'visible_changed', function () { return _this.markerChangeListener(marker, false); }));
        }
        if (!this.markersWontMove) {
            listenerRefs.push(google.maps.event.addListener(marker, 'position_changed', function () { return _this.markerChangeListener(marker, true); }));
        }
        if (spiderClickHandler) {
            listenerRefs.push(google.maps.event.addListener(marker, 'spider_click', spiderClickHandler));
        }
        this.markerListenerRefs.push(listenerRefs);
        this.markers.push(marker);
        if (this.basicFormatEvents) {
            // if using basic events, just format this marker as unspiderfied
            this.trigger('format', marker, OverlappingMarkerSpiderfier.markerStatus.UNSPIDERFIED);
        }
        else {
            // otherwise, format as unspiderfiable now, and recalculate all marker formatting at end of run loop
            this.trigger('format', marker, OverlappingMarkerSpiderfier.markerStatus.UNSPIDERFIABLE);
            this.formatMarkers();
        }
        return this; // return self, for chaining
    };
    OverlappingMarkerSpiderfier.prototype.removeMarker = function (marker) {
        this.forgetMarker(marker);
        marker.setMap(null);
        return this;
    };
    OverlappingMarkerSpiderfier.prototype.forgetMarker = function (marker) {
        if (marker['_omsData']) {
            this.unspiderfy();
        }
        var index = this.markers.indexOf(marker);
        if (index !== -1) {
            var listenerRefs = this.markerListenerRefs.splice(index, 1)[0];
            listenerRefs.forEach(function (listener) { return listener.remove(); });
            delete marker['_oms'];
            this.markers.splice(index, 1);
            this.formatMarkers();
        }
        return this;
    };
    OverlappingMarkerSpiderfier.prototype.removeAllMarkers = function () {
        var markers = this.getMarkers();
        this.forgetAllMarkers();
        markers.forEach(function (marker) { return marker.setMap(null); });
        return this;
    };
    OverlappingMarkerSpiderfier.prototype.forgetAllMarkers = function () {
        this.unspiderfy();
        this.markerListenerRefs.forEach(function (listeners) {
            listeners.forEach(function (listener) { return listener.remove(); });
        });
        this.markers.forEach(function (marker) {
            delete marker['_oms'];
        });
        this.initMarkerArrays();
        return this;
    };
    OverlappingMarkerSpiderfier.prototype.getMarkers = function () {
        return this.markers.slice();
    };
    OverlappingMarkerSpiderfier.prototype.addListener = function (eventName, listener) {
        this.listeners[eventName] = this.listeners[eventName] || [];
        this.listeners[eventName].push(listener);
        return this;
    };
    OverlappingMarkerSpiderfier.prototype.removeListener = function (eventName, listener) {
        if (this.listeners[eventName]) {
            var index = this.listeners[eventName].indexOf(listener);
            if (index !== -1) {
                this.listeners[eventName].splice(index, 1);
            }
        }
        return this;
    };
    OverlappingMarkerSpiderfier.prototype.clearListeners = function (eventName) {
        this.listeners[eventName] = [];
        return this;
    };
    OverlappingMarkerSpiderfier.prototype.markersNearMarker = function (marker, firstOnly) {
        if (firstOnly === void 0) { firstOnly = false; }
        if (this.projectionHelper.getProjection() == null) {
            throw 'Must wait for \'idle\' event on map before calling markersNearMarker';
        }
        var nDist = this.nearbyDistance;
        var pxSq = nDist * nDist;
        var markerPt = this.llToPt(marker.position);
        var markers = [];
        for (var i = 0; i < this.markers.length; i++) {
            var current = this.markers[i];
            if (current === marker || current.map == null || !current.getVisible()) {
                continue;
            }
            var mPt = this.llToPt(current['_omsData'] && current['_omsData'].usualPosition || current.position);
            if (OverlappingMarkerSpiderfier.ptDistanceSq(mPt, markerPt) < pxSq) {
                markers.push(current);
                if (firstOnly) {
                    break;
                }
            }
        }
        return markers;
    };
    OverlappingMarkerSpiderfier.prototype.markersNearAnyOtherMarker = function () {
        // *very* much quicker than calling markersNearMarker in a loop
        var mData = this.markerProximityData();
        var result = [];
        for (var i = 0; i < this.markers.length; i++) {
            var m = this.markers[i];
            if (mData[i].willSpiderfy) {
                result.push(m);
            }
        }
        return result;
    };
    OverlappingMarkerSpiderfier.prototype.unspiderfy = function (markerNotToMove) {
        if (markerNotToMove === void 0) { markerNotToMove = null; }
        if (!this.spiderfied) {
            return this;
        }
        this.unspiderfying = true;
        var unspiderfiedMarkers = [];
        var nonNearbyMarkers = [];
        for (var i = 0; i < this.markers.length; i++) {
            var marker = this.markers[i];
            if (marker['_omsData']) {
                marker['_omsData'].leg.setMap(null);
                if (marker !== markerNotToMove) {
                    marker.setPosition(marker['_omsData'].usualPosition);
                }
                marker.setZIndex(marker['_omsData'].usualZIndex);
                var listeners = marker['_omsData'].hightlightListeners;
                if (listeners) {
                    google.maps.event.removeListener(listeners.highlight);
                    google.maps.event.removeListener(listeners.unhighlight);
                }
                delete marker['_omsData'];
                if (marker !== markerNotToMove) {
                    // if marker is markerNotToMove, formatMarkers is about to be called anyway
                    var status_1 = this.basicFormatEvents ?
                        OverlappingMarkerSpiderfier.markerStatus.UNSPIDERFIED :
                        OverlappingMarkerSpiderfier.markerStatus.SPIDERFIABLE; // unspiderfying? must be spiderfiable
                    this.trigger('format', marker, status_1);
                }
                unspiderfiedMarkers.push(marker);
            }
            else {
                nonNearbyMarkers.push(marker);
            }
        }
        this.unspiderfying = false;
        this.spiderfied = false;
        this.trigger('unspiderfy', unspiderfiedMarkers, nonNearbyMarkers);
        return this; // return self, for chaining
    };
    OverlappingMarkerSpiderfier.markerStatus = MarkerStatus;
    OverlappingMarkerSpiderfier.optionAttributes = [
        'markersWontHide',
        'markersWontMove',
        'basicFormatEvents',
        'keepSpiderfied',
        'ignoreMapClick',
        'nearbyDistance',
        'circleSpiralSwitchover',
        'circleFootSeparation',
        'circleStartAngle',
        'spiralFootSeparation',
        'spiralLengthStart',
        'spiralLengthFactor',
        'legWeight',
    ];
    return OverlappingMarkerSpiderfier;
}());

exports.MarkerStatus = MarkerStatus;
exports.OverlappingMarkerSpiderfier = OverlappingMarkerSpiderfier;

Object.defineProperty(exports, '__esModule', { value: true });

})));


},{}]},{},[4]);
